export function getPropValue(sourceObject: any, dotNotationPath: string) {
  if (!sourceObject || !dotNotationPath) return '';
  let returnData = sourceObject;
  dotNotationPath.split(".").forEach(subPath => {
    if (returnData === null || returnData === undefined) {
      returnData = '';
      return;
    }
    if (Array.isArray(returnData)) {
      returnData = returnData[0] ? returnData[0][subPath] : '';
      return;
    }
    returnData = returnData[subPath] != undefined ? returnData[subPath] : '';
  });
  return returnData;
}


export function dateFormatYYYYMMDDTODDMMYYYY(input: string): string  {
  const parts = input.split('-');
  if (parts.length !== 3) {
    throw new Error('Неверный формат даты. Ожидается yyyy-mm-dd');
  }
  const [year, month, day] = parts;
  return `${day}.${month}.${year}`;
}
